import React from 'react';
import '../scss/confirm-delete-modal.scss';
import { useTranslation } from 'react-i18next';


interface ConfirmDeleteModalProps {
    open: boolean;
    title?: string;
    description?: string;
    loading?: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

const ConfirmDeleteModal: React.FC<ConfirmDeleteModalProps> = ({
    open,
    title = 'Delete Invoice',
    description = 'Are you sure you want to delete this draft invoice?',
    loading = false,
    onCancel,
    onConfirm,
}) => {
    if (!open) return null;
    const { t } = useTranslation();


    return (
        <div className="confirm-modal-backdrop">
            <div className="confirm-modal">
                <h3>{title}</h3>
                <p>{description}</p>

                <div className="confirm-modal-actions">
                    <button
                    className="btn-cancel"
                    onClick={onCancel}
                    disabled={loading}
                    >
                        {t('CANCEL_CONFIRM')}
                    </button>

                    <button
                        className="btn-delete"
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {t('DELETE_CONFIRM')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDeleteModal;
